import { Platform, StyleSheet } from "react-native";
import { theme } from "../../theme";
export const styles = StyleSheet.create({
    defaults: {
        fontFamily: Platform.select({ default: "Proxima", ios: "ProximaBold" }),
        margin: 0,
    },
    heading1: {
        ...theme.fontDefaults.xlarge4,
        fontWeight: "bold",
    },
    heading2: {
        ...theme.fontDefaults.xlarge3,
        fontWeight: "bold",
    },
    heading3: {
        ...theme.fontDefaults.xlarge2,
        fontWeight: "bold",
    },
    heading4: {
        ...theme.fontDefaults.xlarge,
        fontWeight: "bold",
    },
    heading5: {
        ...theme.fontDefaults.large,
        fontWeight: "bold",
    },
    heading6: {
        ...theme.fontDefaults.base,
        fontWeight: "normal",
    },
});
//# sourceMappingURL=Heading.styles.js.map